<template>
    <div class="course-service-image-row" :class="{'mini': mode === 'mini'}">
        <div class="use-default-checkbox" @click="changeServiceImageMode">
            <div :class="{selected:isSystem}">
                <a-icon v-if="isSystem" style="color: white" type="check"/>
            </div>
            <span>直接使用小程序已上传客服二维码</span>
        </div>
        
        <div v-if="!isSystem" class="se-image-box">
            <div class="se-image-row">
                <upload-image :image-url="customerServiceImg" usage="course-service-img"
                              @change="changeCustomerServiceImg"></upload-image>
                
                <div v-if="mode !== 'mini'">（上传客服二维码后，报名后会出现该二维码供用户扫码添加）</div>
            </div>
            <div class="thumb-tips">
                <div class="tips" v-if="mode === 'mini'">示例图</div>
                图片格式必须为:png,bmp,jpeg,jpg;不可大于2M;<br>
                建议使用png格式图片，以保持最佳效果;建议图片为400px *400px
            </div>
        
        </div>
        <div class="se-image-row" v-else>
            <template v-if="!serviceImages.length">
                <div class="tips text-danger ml-0">暂无客服二维码</div>
            </template>
            <div class="se-image" v-else>
                <img :src="serviceImages[0]" width="102" alt="">
            </div>
            <div class="tips" v-if="mode === 'mini'">示例图</div>
            <div class="tips" v-else>（上传客服二维码后，报名后会出现该二维码供用户扫码添加）</div>
        </div>
    
    </div>
</template>

<script>

import UploadImage from "@/components/UploadImage.vue";
import api from "@/repo/api";

export default {
    components: {UploadImage},
    props: {
        isSystem: Number,
        customerServiceImg: String,
        mode: String
    },
    data() {
        return {
            serviceImages: []
        }
    },
    mounted() {
        this.fetchServiceImages();
    },
    methods: {
        changeServiceImageMode() {
            this.$emit('update:isSystem', this.isSystem > 0 ? 0 : 1)
        },
        async fetchServiceImages() {
            const data = await api.get('/ast-master/service-images');
            this.serviceImages = data.data
        },
        changeCustomerServiceImg(url) {
            this.$emit('update:customerServiceImg', url)
        }
    }
}
</script>

<style lang="scss" scoped>

.course-service-image-row {
    &.mini {
        .se-image-box {
            display: flex;
            align-items: center;
            gap: 10px;
        }
        
        .thumb-tips{
            font-size: 12px;
            color: #999999;
            font-weight: 400;
            line-height: 20px;
            .tips{
                color: #FBB03B;
                margin-bottom: 3px;
            }
        }
        
        
    }
    
    .use-default-checkbox {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        padding: 0 16px;
        width: 728px;
        cursor: pointer;
        user-select: none;
        
        div {
            width: 16px;
            height: 16px;
            border: 1px solid rgb(51, 51, 51);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            margin-right: 8px;
            
            &.selected {
                background-color: rgb(51, 51, 51);
            }
        }
    }
    
    .se-image-row {
        margin-top: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        
        .tips {
            margin-left: 10px;
            padding-bottom: 4px;
            font-size: 12px;
            color: #FBB03B;
        }
    }
    
    .thumb-tips {
        margin-top: 12px;
    }
}
</style>